import {Platform} from 'react-native';
import {SafeAreaView} from 'react-native-safe-area-context';
import FastImage from 'react-native-fast-image';
import { isIphoneX } from 'react-native-iphone-screen-helper';
import {RFPercentage, RFValue} from 'react-native-responsive-fontsize';
import styled from 'styled-components/native';

export const Container = styled(SafeAreaView)`
  flex: 1;
  justify-content: center;

  align-items: center;
`;

export const NotFoundContent = styled.View`
  width: 63%;
  flex: 1;
  justify-content: center;
    margin-top: ${RFPercentage(5)}px;
  align-items: center;
`;

//@ts-ignore
export const NotFoundImage = styled(FastImage)`
  width: ${RFValue(100)}px;
  height: ${RFValue(100)}px;
  margin-bottom: ${RFValue(6)}px;
`;
export const NotFoundTitle = styled.Text`
  font-size: ${RFValue(14)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.title};
  text-align: center;
  margin-bottom: ${RFValue(6)}px;
`;

export const NotFoundText = styled.Text`
  font-size: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.regular};
  color: ${({theme}) => theme.colors.text_dark};
  text-align: center;
`;

export const Footer = styled.View`
  padding: 0 24px;
  padding-bottom: ${!isIphoneX() ? RFValue(20) : 0}px;
  width: 100%;
`;
